import { createSlice } from '@reduxjs/toolkit';
import { AppPlatform } from '@trinity/chat';
import { config } from '@/config';
import type { AppFeatures } from './interfaces';
import { sharedActions } from './shared-actions';


const initialState: AppFeatures = {
  autoTagFiles: false,
  deleteChatsOnSessionEnd: false,
  hcpProfiles: false,
  hcpSchedulingAssistant: false,
  workspaces: false,
  workspaceBrands: false,
  chatVoiceInput: false,
  chatReadAloud: false,
  chatVoiceMode: false,
  chatVoiceSource: 'browser',
  chatWelcomeScreen: false,
  predictiveScheduling: false,
  smartRouting: false,
  speechServicesProvider: config().APP_PLATFORM === AppPlatform.enum.veeva ? 'custom' : 'browser',
  uploadFiles: false,
  copyChatMessages: false,
  shareChats: false,
  exportChatData: false,
  engagementResponseLabels: false,
  engagementFilter: false,
  chatIconVisibility: false,
  supportIcon: '',
  documentIconVisibility: false,
  followUps: false,
  browserTabName: null,
  chatAuraIframesEnabled: false,
  maxUserChatQueries: null,
  chatFileUploads: false,
  chatGuidelines: null,
  disableChatInputWithLandingCards: false,
  homeScreen: null,
  homeButton: false,
  chatContextSelector: true,
  applicationTooltip: null,

  hcpProfileElements: {
    contactInformation: false,
    interactionsSummary: false,
    keyDiscussionQuestions: false,
    keyInsights: false,
    leaderTopics: false,
    clinicalTrials: false,
    publications: false,
    conferencePresence: false,
  },
  homeButtonTopHeader: false,
};

export const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {

  },
  extraReducers: builder => {
    builder.addCase(sharedActions.appStatedLoaded, (_, action) => {
      return action.payload.features;
    });
    builder.addCase(sharedActions.userLoggedOutAction, () => {
      return initialState;
    });
  },
});

export default featuresSlice.reducer;